import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./IconProgressBar.css";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { faCheck } from "@fortawesome/pro-light-svg-icons";

function IconProgressBar({ icons, currentPage }) {
  // react-step-progress-bar puts step i at 100 / (count - 1) * i, fills the bar
  // to `percent`, and marks a step done once its position <= percent. The fill
  // only lands on a step if it is derived from that same formula: the previous
  // hardcoded ladder (8/23/40/58/75/100) sat past every step, which is what
  // made the green bar overshoot.
  const lastStep = Math.max(icons.length - 1, 1);
  const step = Math.min(Math.max(currentPage, 0), lastStep);
  const progress = (100 / lastStep) * step;

  return (
    <div>
      <div className="iconProgressBarContainer">
        <ProgressBar percent={progress} filledBackground={"#418172"}>
          {icons.map((icon, index) => (
            <Step accomplished={false} key={index}>
              {({ accomplished }) => (
                <div
                  style={
                    accomplished
                      ? { color: "#418172", borderColor: "#418172" }
                      : {}
                  }
                >
                  {accomplished && (
                    <FontAwesomeIcon className="checkMark" icon={faCheck} />
                  )}

                  <div
                    style={accomplished ? { borderColor: "#418172" } : {}}
                    className="iconProgressBarItem"
                  >
                    <FontAwesomeIcon className={icon.class} icon={icon.name} />
                    <p
                      style={accomplished ? { color: "#418172" } : {}}
                      className="iconPageTitle"
                    >
                      {icon.pageTitle}
                    </p>
                  </div>
                </div>
              )}
            </Step>
          ))}
        </ProgressBar>
      </div>
    </div>
  );
}

export default IconProgressBar;
